import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  TablePagination,
  Collapse,
  IconButton,
  Pagination,
  FormControlLabel,
  Checkbox,
  Divider,
  Modal,
  Select,
  MenuItem,
  InputLabel,
  Tooltip,
} from '@mui/material';
import { ExpandMore, ExpandLess, Search } from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import baseURL from '../config';
import Navbar from '../Navbar/Navbar';
import PendingInvoices from './InvoiceDetails/PendingInvoices';
import CompletedInvoices from './InvoiceDetails/CompletedInvoices';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CrewAgentDetails = () => {
  const { agentId, crewingAgentId } = useParams();
  const [assignedVessels, setAssignedVessels] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [agentDetails, setAgentDetails] = useState({});
  const [contractStatus, setContractStatus] = useState([]);
  const [bankDetails, setBankDetails] = useState({});
  const [firstContractDate, setFirstContractDate] = useState('N/A');
  const [crewingAgenTCharges, setCrewingAgenTCharges] = useState([]);
  const [showVessels, setShowVessels] = useState(false);
  const [showContracts, setShowContracts] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [approved, setApproved] = useState(bankDetails.approved);
  const [approved, setApproved] = useState(bankDetails?.approved ?? false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [crewingAgentCharges, setCrewingAgentCharges] = useState([]); // Add this line
  const creatorId = localStorage.getItem("user id");
  const [documentAvailability, setDocumentAvailability] = useState({}); // State to track document availability

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const token = localStorage.getItem("token"); // Adjust if stored elsewhere

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const [agentResponse, vesselResponse] = await Promise.all([
          axios.get(`${baseURL}/api/getcrewingAgentDetails`, config),
          axios.get(`${baseURL}/api/getvesselAgent/${agentId}`, config).catch(err => {
            if (err.response?.status === 404) {
              console.warn("No vessels found for this agent.");
              return { data: {} };
            }
            throw err;
          }),
        ]);

        let contractsResponse = { data: { contracts: [] } };
        let contractStatusResponse = { data: {} };
        let firstContractResponse = { data: null };
        let ChargesForCrewingAgent = { data: {} };
        let BankDetails = { data: {} };

        try {
          firstContractResponse = await axios.get(
            `${baseURL}/api/firstContractAssignedTocrewingAgent/${agentId}`,
            config
          );
        } catch (err) {
          if (err.response?.status === 404) {
            console.warn("No first contract found for this agent.");
          } else {
            throw err;
          }
        }

        try {
          contractsResponse = await axios.get(
            `${baseURL}/api/getContractDetailsByCrewAgentCount/${agentId}`,
            config
          );
        } catch (err) {
          if (err.response?.status === 404) {
            console.warn("No contracts found for this agent.");
          } else {
            throw err;
          }
        }

        try {
          contractStatusResponse = await axios.get(
            `${baseURL}/api/getContractStatusDetails`,
            config
          );
        } catch (err) {
          if (err.response?.status === 404) {
            console.warn("No contract status details found.");
          } else {
            throw err;
          }
        }

        try {

          ChargesForCrewingAgent = await axios.get(
            `${baseURL}/api/getChargesDetailsByCrewingAgentId/${agentId}`,
            config
          );
          setCrewingAgenTCharges(ChargesForCrewingAgent.data);
          console.log("const token = localStorage.getItem", ChargesForCrewingAgent?.data)
        } catch (err) {
          if (err.response?.status === 404) {
            console.warn("No charge details found for this agent.");
          } else {
            throw err;
          }
        }

        try {
          BankDetails = await axios.get(
            `${baseURL}/api/CrewinngAccount/CrewingAgentADetailsccount/${agentId}`,
            config
          );
          setBankDetails(BankDetails.data.data);
        } catch (err) {
          if (err.response?.status === 404) {
            console.warn("No bank details found for this agent.");
          } else {
            throw err;
          }
        }

        // Set crewing agent details
        const agentData = agentResponse.data.find(agent => agent._id === agentId) || {};
        setAgentDetails(agentData);

        // Merge vessel details
        const vesselData = vesselResponse.data?.vesselAgent || {};
        const combinedVessels = [
          ...(vesselData.vesselIds || []),
          ...(vesselData.Vesselname?.map(name => ({
            vesselname: name,
            IMO_Number: "N/A",
            Flag: "N/A",
          })) || []),
        ].reduce((acc, vessel) => {
          if (!acc.some(v => v.vesselname === vessel.vesselname)) {
            acc.push(vessel);
          }
          return acc;
        }, []);

        setAssignedVessels(combinedVessels.length > 0 ? combinedVessels : []);

        // Merge contracts and contract status
        const contractStatusData = contractStatusResponse.data?.data || [];
        const contractsData = contractsResponse.data?.contracts || [];

        const mergedContracts = contractsData.map(contract => {
          const matchingStatus = contractStatusData.find(
            status => status.contractId === contract._id
          );

          return {
            ...contract,
            contractId: contract._id,
            crewingAgentId: contract?.crewingAgent?._id,
            ...(matchingStatus || {}),
          };
        });

        setContracts(mergedContracts);
        setContractStatus(contractStatusData);

        if (firstContractResponse.data) {
          setFirstContractDate(formatDateTime(firstContractResponse.data.createdAt));
        }

      } catch (error) {
        console.error("Error fetching details:", error);
      }
    };

    fetchDetails();
  }, [agentId]);


  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  };

  const handleSearch = (data) => {
    return data.filter((row) =>
      Object.values(row)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const renderCellValue = (value) => {
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value);
    }
    return value || 'N/A';
  };
  const checkDocumentAvailability = async (crewingAgentId, contractId) => {
    if (!crewingAgentId || !contractId) {
      setDocumentAvailability((prev) => ({ ...prev, [contractId]: false }));
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${baseURL}/api/payment/getCrewingAgentPaymentById/${crewingAgentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );

      if (response.data && response.data.length > 0) {
        for (const paymentRecord of response.data) {
          const specificPayment = paymentRecord.payments.find((p) => p.contractId === contractId);

          if (specificPayment && specificPayment.invoicePath) {
            setDocumentAvailability((prev) => ({ ...prev, [contractId]: true })); // Document is available
            return;
          }
        }
      }
      setDocumentAvailability((prev) => ({ ...prev, [contractId]: false })); // Document is not available
    } catch (error) {
      console.error("Error checking document availability:", error);
      setDocumentAvailability((prev) => ({ ...prev, [contractId]: false })); // Document is not available
    }
  };

  const handlePDFClick = async (crewingAgentId, contractId) => {
    if (!crewingAgentId || !contractId) {
      toast.error("Crewing Agent ID or Contract ID is missing!");
      return;
    }

    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${baseURL}/api/payment/getCrewingAgentPaymentById/${crewingAgentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );



      if (response.data && response.data.length > 0) {
        // Loop through the response data and check inside `payments`
        for (const paymentRecord of response.data) {
          const specificPayment = paymentRecord.payments.find(p => p.contractId === contractId);

          if (specificPayment) {
            const invoicePath = specificPayment.invoicePath;

            if (invoicePath) {
              const pdfUrl = `${baseURL}/${invoicePath.replace(/\\/g, "/")}`;
              window.open(pdfUrl, "_blank");
              return; // Stop checking further once we find the matching contract
            }
          }
        }
        toast.error("No invoice available for this contract.");
      } else {
        toast.error("No payment data found.");
      }
    } catch (error) {
      console.error("Error fetching payment details:", error);
      toast.error("Failed to load invoice.");
    }
  };


  const renderSection = (label, data = [], show, setShow, contractsPerPage = 10, setContractsPerPage) => {
    const [searchTerm, setSearchTerm] = React.useState("");
    const [currentPage, setCurrentPage] = useState(1);

    // Filter data based on search input
    const filteredData = data.filter((contract) =>
      contract?.crewdetails?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contract?.vesselOwner?.company_shortname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contract?.ShipDetails?.vesselname?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination logic
    const indexOfLastContract = currentPage * contractsPerPage;
    const indexOfFirstContract = indexOfLastContract - contractsPerPage;
    const currentContracts = filteredData.slice(indexOfFirstContract, indexOfLastContract);

    return (
      <Card style={{ marginBottom: "24px" }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              Total {label}: {filteredData.length}
            </Typography>
            <IconButton onClick={() => setShow(!show)}>
              {show ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>

          <Collapse in={show} timeout="auto" unmountOnExit>
            <Box display="flex" justifyContent="space-between" alignItems="center" marginTop={2}>
              {/* Search Bar */}
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
              />
            </Box>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1976D2", color: "white" }}>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Sr. No.</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Vessel Owner</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Crew</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Form I</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentContracts.length > 0 ? (
                  currentContracts.map((contract, index) => (
                    <TableRow key={contract._id || index}>
                      <TableCell>{(currentPage - 1) * contractsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Typography fontWeight="bold">
                          Contract Created At: {new Date(contract.createdAt).toLocaleString()}
                        </Typography>
                        <Typography>Company: {contract.vesselOwner?.company_shortname || "N/A"}</Typography>
                        <Typography>Vessel: {contract.ShipDetails?.vesselname}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography fontWeight="bold">Name: {contract?.crewdetails?.name}</Typography>
                        <Typography>Indos No.: {contract?.crewdetails?.indosno || "N/A"}</Typography>
                        <Typography>Email: {contract?.crewdetails?.email}</Typography>
                        <Typography>Rank: {contract?.crewdetails?.rankname}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {contract?.formI?.filePath ? (
                            <a
                              href={`${baseURL}/${contract.formI.filePath.replace(/\\/g, "/")}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <PictureAsPdfIcon sx={{ color: "red", fontSize: 20 }} />
                            </a>
                          ) : (
                            "No Form I Available"
                          )}
                          <br />
                          Uploaded Date:{" "}
                          {contract?.formI?.uploadedAt
                            ? new Date(contract.formI.uploadedAt).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                            : "N/A"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {documentAvailability[contract.contractId] ? (
                          <Tooltip title="Invoice Generated" arrow>
                            <IconButton
                              onClick={() => handlePDFClick(contract.crewingAgentId, contract.contractId)}
                              sx={{ color: "green", marginLeft: "10px" }}
                            >
                              <PictureAsPdfIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Click to generate invoice" arrow>
                            <Checkbox
                              checked={selectedContracts.some((c) => c._id === contract._id)}
                              onChange={(e) => handleCheckboxChange(e, contract)}
                            />
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No Contracts Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

            </Table>

            {/* Search Bar & Pagination */}

            {/* Pagination */}
            <TablePagination
              component="div"
              count={filteredData.length}
              page={currentPage - 1}  // Adjust for zero-based indexing
              rowsPerPage={contractsPerPage}
              onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}  // Correct function call
              onRowsPerPageChange={(event) => setContractsPerPage(parseInt(event.target.value, 10))}
              rowsPerPageOptions={[5, 10, 25]}
            />

          </Collapse>
        </CardContent>
      </Card>
    );
  };

  const handleApprovalSubmit = async () => {
    try {
      const token = localStorage.getItem("token"); // Adjust if stored differently
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.post(
        `${baseURL}/api/CrewinngAccount/approveCrewingAgentAccount/${bankDetails._id}`,
        { approved },
        config
      );

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      // console.log(error.response.data.message)
      toast.error(error.response.data.message)
    }
  };

  const handleCheckboxChange = (e, contract) => {
    const isChecked = e.target.checked;

    setSelectedContracts((prev) => {
      if (isChecked) {
        // Add the contract if checked
        return [...prev, contract];
      } else {
        // Remove the contract if unchecked
        return prev.filter((c) => c._id !== contract._id); // Use `_id` to uniquely identify contracts
      }
    });

    // Fetch charges for the selected contract from the state
    if (isChecked) {
      const charges = crewingAgenTCharges.find((charge) => charge.crewingAgentId === agentId);
      if (charges) {
        // console.log("Charges for selected contract:");
      } else {
        console.warn("No charges found in state for the selected contract.");
      }
    }
  };

  const handlePaymentChange = (contractId, field, value) => {


    setPaymentDetails((prev) => {
      const existingIndex = prev.findIndex((p) => String(p.contractId) === String(contractId));

      if (existingIndex !== -1) {
        // Update existing payment
        return prev.map((p, index) =>
          index === existingIndex ? { ...p, [field]: value } : p
        );
      } else {
        // Create new payment with proper initial state
        const newPayment = {
          contractId,
          paymentAmount: field === "paymentAmount" ? value : [],
          paymentType: field === "paymentType" ? value : "",
          paymentDate: field === "paymentDate" ? value : "",
          paymentDescription: field === "paymentDescription" ? value : "",
        };


        return [...prev, newPayment];
      }
    });
  };

  const handleSubmit = async () => {


    const finalData = {
      creatorId: creatorId,
      payments: paymentDetails.flatMap((payment) => {


        // Find the matching contract - using contractId
        const contract = selectedContracts.find(
          (c) => String(c.contractId) === String(payment.contractId)
        );



        // Skip invalid entries or empty payment amounts
        if (!contract || !bankDetails?._id || !payment.paymentAmount?.length) {
          // console.log("Skipping due to invalid contract, bank details, or empty payment amount");
          return [];
        }

        // Create a payment entry for each selected amount
        return payment.paymentAmount.map((amount) => ({
          crewingAgentAccountId: bankDetails._id,
          contractId: payment.contractId,
          paymentAmount: amount,
          paymentType: payment.paymentType,
          paymentDate: payment.paymentDate,
          paymentDescription: payment.paymentDescription,
        }));
      }),
    };


    if (!finalData.payments || finalData.payments.length === 0) {
      toast.error("No valid payments to process. Please check your input.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${baseURL}/api/payment/makeCrewingAgentPayment`, finalData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });


      toast.success("Payments processed successfully!");
      setOpenModal(false);
    } catch (error) {
      console.error("Error processing payments:", error);
      toast.error("Failed to process payments. Please try again.");
    }
  };

  const formatDate = (date) => {
    if (!date) return "Invalid Date";
    const d = new Date(date);
    return isNaN(d) ? "Invalid Date" : d.toLocaleDateString("en-GB");
  };

  const renderVesselTable = (data) => (
    <Box>
      {/* Search Input */}
      <TextField
        label="Search Vessel"
        variant="outlined"
        fullWidth
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ mb: 2 }}
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976D2", "& th": { color: "white", fontWeight: "bold" } }}>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Ship Information</TableCell>
              <TableCell>Insurance Details</TableCell>
              <TableCell>Certificates</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {handleSearch(data)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                  {/* Ship Information */}
                  <TableCell>
                    <Box sx={{ padding: 1 }}>
                      <Typography variant="body1">
                        <strong>Vessel Name:</strong>{" "}
                        <span style={{ background: "blue", color: "white", padding: "2px 6px", borderRadius: "5px" }}>
                          {row.vesselname || "N/A"}
                        </span>
                      </Typography>
                      <Typography variant="body1">
                        <strong>IMO Number:</strong> {row.IMO_Number || "N/A"}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Ship Type:</strong> {row.vesseltype || "N/A"}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Ship Flag:</strong> {row.Flag || "N/A"}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Gross Tonnage:</strong> {row.gross_tonage || "N/A"}
                      </Typography>
                      <Typography variant="body1">
                        <strong>kiloWatt/BHP:</strong> {row.kiloWatt || "N/A"}
                      </Typography>
                    </Box>
                  </TableCell>
                  {/* Insurance Details */}
                  <TableCell>
                    <Box sx={{ padding: 1 }}>
                      <Typography variant="body1">
                        <strong>P&I Number:</strong> {row.pipolicynumber || "N/A"}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Policy Date Validity:</strong> {formatDate(row.policydateofv)}
                      </Typography>
                      {new Date(row.policyDate) < new Date() && (
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            background: "#FFCDD2",
                            padding: "2px 6px",
                            borderRadius: "5px",
                            color: "red",
                            fontWeight: "bold",
                          }}
                        >
                          ⚠ Expired
                        </Box>
                      )}
                    </Box>
                  </TableCell>
                  {/* Certificates */}
                  <TableCell>
                    <Box sx={{ padding: 1 }}>
                      <Typography variant="body1">
                        <strong>MLC Cert No.:</strong> {row.mlcCert || "N/A"}
                      </Typography>
                      <Typography variant="body1">
                        <strong>MLC Iss. Date:</strong> {formatDate(row.mlcIssueDate)}
                      </Typography>
                      <Typography variant="body1">
                        <strong>MLC Exp. Date:</strong> {formatDate(row.mlcExpiryDate)}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Financial Security Validity:</strong> {formatDate(row.fsdvalidity)}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={handleSearch(data).length} // Adjusted for filtered data
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );

  useEffect(() => {
    // Pre-check document availability for all contracts
    contracts.forEach((contract) => {
      if (contract.crewingAgentId && contract.contractId) {
        checkDocumentAvailability(contract.crewingAgentId, contract.contractId);
      }
    });
  }, [contracts]);

  //   useEffect(() => {
  //   const fetchChargesDetails = async () => {
  //      const token = localStorage.getItem("token");
  //     try {
  //       const chargesRes = await axios.get(
  //         `${baseURL}/api/getChargesDetailsByCrewingAgentId/${agentId}`,
  //         {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }
  //       );

  //       if (chargesRes.data) {
  //         setChargesDetails(chargesRes.data);
  //         console.log("Charges Details:", chargesRes.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching charges details:", error);
  //     }
  //   };

  //   if (agentId) {
  //     fetchChargesDetails(); // ✅ call async function
  //   }
  // }, [agentId]);

  return (
    <>
      <Navbar />
      <Box padding={4}>
        <Card sx={{ marginBottom: '24px', padding: '16px' }}>
          <CardContent>
            <Grid container spacing={3} sx={{ justifyContent: 'space-between' }}>
              {/* Crewing Agent Details */}
              <Grid item xs={3}>
                <Card sx={{ p: 2, boxShadow: 3, backgroundColor: "#f5f5f5" }}>
                  <Typography variant="h6" fontWeight="bold">
                    Crewing Agent Details
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="subtitle1"><strong>Name:</strong> {agentDetails.agentName}</Typography>
                  <Typography variant="body2"><strong>Registered Date:</strong> {formatDateTime(agentDetails.createdAt)}</Typography>
                  <Typography variant="body2"><strong>First Contract Date:</strong> {firstContractDate}</Typography>
                </Card>
              </Grid>
              {/* Contact Person Details */}
              <Grid item xs={3}>
                <Card sx={{ p: 2, boxShadow: 3, backgroundColor: "#f5f5f5" }}>
                  <Typography variant="h6" fontWeight="bold">
                    Contact Person Details
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="subtitle1">
                    <strong>Name:</strong> {agentDetails.contactPerson?.title} {agentDetails.contactPerson?.name}
                  </Typography>
                  <Typography variant="body2"><strong>Contact Number:</strong> {agentDetails.contactNumber}</Typography>
                  <Typography variant="body2"><strong>Email:</strong> {agentDetails.email}</Typography>
                  <Typography variant="body2"><strong>Address:</strong> {agentDetails.address}</Typography>
                  <Typography variant="body2"><strong>Country:</strong> {agentDetails.country}</Typography>
                </Card>
              </Grid>
              {/* Bank Details */}
              <Grid item xs={3}>
                <Card sx={{ p: 2, boxShadow: 3, backgroundColor: "#f5f5f5" }}>
                  <Typography variant="h6" fontWeight="bold">
                    Bank Details
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  {bankDetails ? (
                    bankDetails.crewingAgentName ? (
                      <>
                        <Typography variant="subtitle1"><strong>Bank Holder Name:</strong> {bankDetails.BankHolderName}</Typography>
                        <Typography variant="body2"><strong>Account Number:</strong> {bankDetails.accountNumber}</Typography>
                        <Typography variant="body2"><strong>Bank Name:</strong> {bankDetails.bankName}</Typography>
                        <Typography variant="body2"><strong>IFSC Code:</strong> {bankDetails.ifscCode}</Typography>
                        <Typography variant="body2" sx={{ color: bankDetails.approved ? "green" : "red" }}>
                          <strong>Approved:</strong> {bankDetails.approved ? "✅ Yes" : "❌ No"}
                        </Typography>

                        {!bankDetails.approved && (
                          <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
                            <FormControlLabel
                              control={<Checkbox checked={approved} onChange={(e) => setApproved(e.target.checked)} />}
                              label="Approve"
                            />
                            <Button variant="contained" color="primary" size="small" onClick={handleApprovalSubmit} disabled={!approved}>
                              Submit
                            </Button>
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No Bank Details available for this agent.
                      </Typography>
                    )
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No Bank Details Available.
                    </Typography>
                  )}
                </Card>
              </Grid>
              
              
            </Grid>
          </CardContent>
          {/* Crewing Agent Charges */}
             <Grid item xs={12}>
  <Card sx={{ p: 2, boxShadow: 3, backgroundColor: "#f5f5f5", borderRadius: 2 }}>
    <Typography variant="h6" fontWeight="bold">
      Charges
    </Typography>
    <Divider sx={{ my: 1 }} />

    {crewingAgenTCharges.length > 0 ? (
      crewingAgenTCharges.map((charge) => (
        <Box key={charge._id}>
          <Typography variant="h5" gutterBottom color="primary">
            Invoice Charges Details
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {/* Basic Info */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Agent Name:</strong> {charge.crewingAgentName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Currency:</strong> {charge.currency}
              </Typography>
            </Grid>
          </Grid>

          {/* All Charges in One Row */}
          <Grid container spacing={2}>
            {/* Manning Fee (New Joiner) */}
            <Grid item xs={12} md={3}>
              <Typography variant="h6">Manning Fee (New Joiner)</Typography>
              <Typography>Senior Officer: {charge.manningFeeForNewJoiner?.seniorOfficer}</Typography>
              <Typography>Junior Officer: {charge.manningFeeForNewJoiner?.juniorOfficer}</Typography>
              <Typography>Rating: {charge.manningFeeForNewJoiner?.rating}</Typography>
            </Grid>

            {/* Manning Fee (Rejoiner) */}
            <Grid item xs={12} md={3}>
              <Typography variant="h6">Manning Fee (Rejoiner)</Typography>
              <Typography>Senior Officer: {charge.manningFeeForRejoiner?.seniorOfficer}</Typography>
              <Typography>Junior Officer: {charge.manningFeeForRejoiner?.juniorOfficer}</Typography>
              <Typography>Rating: {charge.manningFeeForRejoiner?.rating}</Typography>
            </Grid>

            {/* Manning Fee (Owner Proposed) */}
            <Grid item xs={12} md={3}>
              <Typography variant="h6">Manning Fee (Owner Proposed)</Typography>
              <Typography>Senior Officer: {charge.manningFeeForOwnerProposed?.seniorOfficer}</Typography>
              <Typography>Junior Officer: {charge.manningFeeForOwnerProposed?.juniorOfficer}</Typography>
              <Typography>Rating: {charge.manningFeeForOwnerProposed?.rating}</Typography>
            </Grid>

            {/* Other Charges */}
            <Grid item xs={12} md={3}>
              <Typography variant="h6">Other Charges</Typography>
              <Typography>One-Time Finder’s Fee: {charge.oneTimeFindesFee}</Typography>
              <Typography>
                Crew Welfare: {charge.crewWelfare?.amount} ({charge.crewWelfare?.perDayOrPerMonth})
              </Typography>
              <Typography>
                Retention Fee: {charge.retentionFee?.amount} ({charge.retentionFee?.perDayOrPerMonth})
              </Typography>
            </Grid>
          </Grid>
        </Box>
      ))
    ) : (
      <Typography>No charges found.</Typography>
    )}
  </Card>
</Grid>

          <Box display="flex" justifyContent="space-between" alignItems="center" marginTop={2}>
            <PendingInvoices agentId={agentId} />
            <CompletedInvoices agentId={agentId} />
          </Box>
        </Card>
        <Card style={{ marginBottom: '24px' }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Total Vessels: {assignedVessels.length}</Typography>
              <IconButton onClick={() => setShowVessels(!showVessels)}>
                {showVessels ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Box>
            <Collapse in={showVessels} timeout="auto" unmountOnExit>
              {renderVesselTable(assignedVessels)}
            </Collapse>
          </CardContent>
        </Card>
        {renderSection('Contracts', contracts, showContracts, setShowContracts)}

        {openModal && selectedContracts.length > 0 && (
          <Modal open={openModal} onClose={() => setOpenModal(false)}>
            <Box
              sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: 3,
                width: "50%",
                margin: "auto",
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6">Enter Payment Details</Typography>
              <Divider sx={{ my: 1 }} />
              {selectedContracts.map((contract) => {
                const charges = crewingAgenTCharges[0] || {
                  JoinerWithCrewWelfare: "N/A",
                  RejionerWithCrewWelfare: "N/A",
                  JoinerWithoutCrewWelfare: "N/A",
                  RejionerWithoutCrewWelfare: "N/A",
                };

                // Find payment details for this contract
                const paymentDetail = paymentDetails.find(
                  (p) => String(p.contractId) === String(contract.contractId)
                ) || {
                  paymentAmount: [],
                  paymentType: "",
                  paymentDate: "",
                  paymentDescription: "",
                };

                return (
                  <Card key={contract._id} sx={{ p: 2, mb: 2 }}>
                    <Typography fontWeight="bold">Company: {contract.vesselOwner?.company_shortname || "N/A"}</Typography>
                    <Typography>Vessel: {contract.ShipDetails?.vesselname}</Typography>
                    <Typography>Crew: {contract?.crewdetails?.name}</Typography>
                    <Select
                      multiple
                      fullWidth
                      value={paymentDetail.paymentAmount || []}
                      onChange={(e) => handlePaymentChange(contract.contractId, "paymentAmount", e.target.value)}
                      displayEmpty
                      renderValue={(selected) => (selected.length === 0 ? "Select Amount" : selected.join(", "))}
                      sx={{ mt: 1 }}
                    >
                      <MenuItem disabled value="">
                        Select Amount
                      </MenuItem>
                      <MenuItem value={charges.JoinerWithCrewWelfare}>
                        Joiner With Crew Welfare: {charges.JoinerWithCrewWelfare}
                      </MenuItem>
                      <MenuItem value={charges.RejionerWithCrewWelfare}>
                        Rejoiner With Crew Welfare: {charges.RejionerWithCrewWelfare}
                      </MenuItem>
                      <MenuItem value={charges.JoinerWithoutCrewWelfare}>
                        Joiner Without Crew Welfare: {charges.JoinerWithoutCrewWelfare}
                      </MenuItem>
                      <MenuItem value={charges.RejionerWithoutCrewWelfare}>
                        Rejoiner Without Crew Welfare: {charges.RejionerWithoutCrewWelfare}
                      </MenuItem>
                    </Select>
                    <Box sx={{ mt: 2 }}>
                      <InputLabel id={`payment-type-label-${contract._id}`}>Payment Type</InputLabel>
                      <Select
                        labelId={`payment-type-label-${contract._id}`}
                        fullWidth
                        value={paymentDetail.paymentType || ""}
                        onChange={(e) => handlePaymentChange(contract.contractId, "paymentType", e.target.value)}
                        displayEmpty
                        sx={{ mt: 1 }}
                      >
                        <MenuItem disabled value="">
                          Select Payment Type
                        </MenuItem>
                        <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                        <MenuItem value="Credit Card">Credit Card</MenuItem>
                        <MenuItem value="Cash">Cash</MenuItem>
                        <MenuItem value="Cheque">Cheque</MenuItem>
                        <MenuItem value="Online">Online</MenuItem>
                      </Select>
                    </Box>
                    <TextField
                      label="Payment Date"
                      type="date"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={paymentDetail.paymentDate || ""}
                      onChange={(e) => handlePaymentChange(contract.contractId, "paymentDate", e.target.value)}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Description"
                      fullWidth
                      placeholder="Enter payment description"
                      value={paymentDetail.paymentDescription || ""}
                      onChange={(e) => handlePaymentChange(contract.contractId, "paymentDescription", e.target.value)}
                      sx={{ mt: 2 }}
                    />
                  </Card>
                );
              })}
              <Button variant="contained" color="primary" onClick={handleSubmit} sx={{ mt: 2 }}>
                Submit Payments
              </Button>
            </Box>
          </Modal>
        )}
        <Button variant="contained" color="primary" onClick={() => setOpenModal(true)} sx={{ mt: 2 }}>
          Proceed to Payment
        </Button>
      </Box>

      <ToastContainer />
    </>
  );
};

export default CrewAgentDetails;